module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container",
    class: {
      mobileMenuSliding: _vm.hasToShowMobileMenu === true, mobileMenuSlidingOut: _vm.hasToShowMobileMenu === false
    }
  }, [_c('instamapsHeader', {
    attrs: {
      "isViewerMode": _vm.isViewer,
      "isUserLogged": _vm.isUserLogged
    },
    on: {
      "langchanged": _vm.langChange,
      "mobileMenuPressed": _vm.showMobileMenu,
      "logout": _vm.userLogout,
      "toProfile": _vm.redirectProfile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scroll-wrapper",
    attrs: {
      "id": "scroller"
    }
  }, [_c('transition', [_c('keep-alive', {
    attrs: {
      "include": "instamapsGallery"
    }
  }, [_c('router-view', {
    attrs: {
      "selectedLang": _vm.selectedLang,
      "hasBreadcrumbs": _vm.hasBreadcrumbs,
      "isUserLogged": _vm.isUserLogged
    },
    on: {
      "loading": _vm.showLoader,
      "loaded": _vm.hideLoader,
      "login": _vm.userLogin,
      "logout": _vm.userLogout,
      "toLogin": _vm.redirectLogin,
      "toHome": _vm.redirectHome
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('instamapsFooter', {
    attrs: {
      "isViewerMode": _vm.isViewer
    }
  }), _vm._v(" "), _c('instamapsLoader', {
    attrs: {
      "show": _vm.isLoading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bb0498"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 284
// module chunks = 0